import getO365ShellShim from '../../utils/getO365ShellShim';

export function openFlexPane(flexPaneId: string): void {
    const shim = getO365ShellShim();
    if (shim) {
        shim.FlexPane.OpenFlexPaneForProvider(flexPaneId);
    }
}
